<template>
  <el-dialog
      :title="title"
      :visible.sync="formVisible"
      width="70%">
    <div class="setup-details-form">
      <h3>Details</h3>
      <el-row :gutter="40">
        <el-col :span="8">
          <section>
            <strong>Created At</strong>
            <span><time-zone-formatter :current-time="details.created_at" /></span>
          </section>
          <section>
            <strong>Device Name</strong>
            <span>{{ details.doorbot_description }}</span>
          </section>
          <section>
            <strong>Ring Device Connected</strong>
            <span>{{ details.doorbot_connected }}</span>
          </section>
        </el-col>
        <el-col :span="8">
          <section>
            <strong>Status</strong>
            <span>{{ details.status }}</span>
          </section>
          <section>
            <strong>Device Id</strong>
            <span>{{ details.doorbot_device_id }}</span>
          </section>
          <section>
            <strong>Client Device Connected</strong>
            <span>{{ details.client_device_connected }}</span>
          </section>
        </el-col>
        <el-col :span="8">
          <section>
            <strong>Client Device Id</strong>
            <span>N/A</span>
          </section>
          <section>
            <strong>Is First</strong>
            <span>{{ details.is_first }}</span>
          </section>
          <section>
            <strong>Changed Owner</strong>
            <span>{{ details.changed_owner }}</span>
          </section>
        </el-col>
      </el-row>

      <h3>Metadata</h3>
      <el-row
          v-for="data in metadata"
          :key="data.id"
          class="setup-details__metadata">
        <el-col :span="12">
          <strong>{{ data.label }}</strong>
          <span>{{ data.value }}</span>
        </el-col>
        <el-col :span="12" />
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { get, startCase } from "lodash";
export default {
  name: "SetupDetails",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      return `Setup #${this.details.id}`;
    },
    metadata() {
      const properties = Object.keys(this.details.metadata);
      return properties.map((property) => ({
        label: startCase(property),
        value: get(this.details, `metadata.${property}`, "not found - error."),
      }));
    },
    formVisible: {
      get: function () {
        return this.visible;
      },
      set: function (arg) {
        if (arg === false) this.$emit("update:visible", false);
      },
    },
  },
};
</script>

<style lang="scss">
.setup-details-form {
  margin: 20px;
  h3 {
    text-transform: uppercase;
  }
  .el-col {
    section {
      margin-bottom: 8px;
      strong {
        color: $--color-dusty-gray;
        margin-right: 14px;
      }
      span {
        font-size: $--font-size-base;
      }
    }
  }
  .setup-details__metadata {
    list-style: none;
    padding: 0;
    line-height: 1.2em;
    &:nth-child(odd) {
      background-color: transparentize($--color-silver, 0.9);
    }
    span {
      float: right;
    }
  }
}
</style>
